export default "__VITE_ASSET__BNICGEBd__"